import { render, staticRenderFns } from "./PopupMenu.vue?vue&type=template&id=edfd8166"
import script from "./popup-menu.ts?vue&type=script&lang=ts&external"
export * from "./popup-menu.ts?vue&type=script&lang=ts&external"
import style0 from "./popup-menu.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports